
export default {
  name: 'v-input-group'
};
